import { notify } from 'app/services/errorReporter';

/**
 * Returns the wasStorageInitiallyAvailable selector
 *
 * @param {Function} getStorageState The selector to access the redux storage
 */
export const wasStorageInitiallyAvailable = (getStorageState) =>
  state => getStorageState(state).wasStorageInitiallyAvailable;

/**
 * Returns the getItem selector
 *
 * @param {Function} validateKey function that checks if the key is allowed to be used
 * @param {Function} getStorageState The selector to access the redux storage
 */
export const getItem = (
  validateKey,
  getStorageState,
) => (state, key) => {
  validateKey(key, { key });

  return getStorageState(state).storage.toJS()[key];
};

/**
 * Returns the hasItem Selector
 *
 * @param {Function} validateKey function that checks if the key is allowed to be used
 * @param {Function} getStorageState The selector to access the redux storage
 */
export const hasItem = (
  validateKey,
  getStorageState,
) => (state, key) => {
  validateKey(key, { key });

  return getStorageState(state).storage.get(key) !== null;
};

export function parseStorageValue(key, jsonValue) {
  try {
    return JSON.parse(jsonValue);
  } catch (error) {
    notify(error, {
      name: 'Storage.couldntParseValue',
      context: { key, value: jsonValue },
    });
    return null;
  }
}
